import { TranslationKeys } from "./TranslationKey";

export const fr: TranslationKeys = {
  "application.examLocationAndDate.chkeckingAvailabilityOfExams": "Vérification de la disponibilité des examens. Veuillez patienter...",
  "application.examLocationAndDate.dateColumn": "Date",
  "application.examLocationAndDate.examColumn": "Examen",
  "application.examLocationAndDate.examFull": "Malheureusement, toutes les places sont déjà complètement réservées. Nous vous recommandons de vous inscrire sur la liste d'attente.",
  "application.examLocationAndDate.examTypeColumn": "Type d'examen",
  "application.examLocationAndDate.languageColumn": "Langue",
  "application.examLocationAndDate.locationColumn": "Localisation",
  "application.examLocationAndDate.moduleColumn": "Module",
  "application.examLocationAndDate.statusColumn": "Statut",
  "application.examLocationAndDate.validattion.examsHaveDifferentLocations": "Il n'est pas possible de réserver le même jour des examens dans des lieux différents. Veuillez adapter votre choix.",
  "application.examLocationAndDateExplanationText": "Veuillez choisir le lieu et la date des examens sélectionnés.",
  "application.moduleSelector.examsColumn": "Examens",
  "application.moduleSelector.noAvaiableModules": "Aucun module disponible",
  "application.moduleSelector.typeColumn": "Type",
  "application.selectedExamsTitle": "Modules et examens sélectionnés",
  "application.uploadVerificationFilesMessage": "Si vous avez des fichiers supplémentaires, veuillez les télécharger maintenant.",
  "application.userSelector.course": "Cours",
  "application.userSelector.examSession": "Session d'examen",
  "application.userSelector.noSelectedModules": "Aucun module sélectionné",
  "cancellationTaskForm.candidateSubHeader": "Candidat",
  "cancellationTaskForm.certificationTypeLabel": "Type de certification",
  "cancellationTaskForm.commentsLabel": "Commentaires",
  "cancellationTaskForm.completeTask": "Sauvegarder et compléter la tâche",
  "cancellationTaskForm.createdOn": "Créée le ",
  "cancellationTaskForm.dateLabel": "Date",
  "cancellationTaskForm.emailLabel": "Email",
  "cancellationTaskForm.examTypeLabel": "Type d'examen",
  "cancellationTaskForm.firstNameLabel": "Prénom",
  "cancellationTaskForm.header": "Tâche d'annulation",
  "cancellationTaskForm.lastNameLabel": "Nom",
  "cancellationTaskForm.locationLabel": "Location",
  "cancellationTaskForm.moduleSubHeader": "Dates",
  "cancellationTaskForm.navigateToCandidateSession": "Aller à la page de certification du candidat",
  "cancellationTaskForm.roomLabel": "Salle",
  "cancellationTaskForm.sessionLabel": "Session",
  "cancellationTaskForm.timeSlotLabel": "Créneau horaire",
  "candidate.button.exportAll": "exporter tous les candidats",
  "candidate.button.new": "Ajouter un nouveau candidat",
  "candidate.button.uploadEdiIds": "télécharger EDI Ids",
  "candidate.disableConfirmationDialog.message": "Veuillez vous assurer que vos détails personnelles sont correctes, car elles ne pourront plus être modifiées par la suite.",
  "candidate.ediIdsDialog.title": "Sélectionner le fichier contenant le EDI Ids",
  "candidate.ediIdsDialog.uploadSuccess": "Succès du téléchargement. Nombre de candidats mis à jour",
  "candidate.field.canton": "Canton",
  "candidate.field.correspondenceLanguage": "Langue de correspondance",
  "candidate.field.invoiceRecipient": "Contact pour les factures",
  "candidate.field.nationality": "Nationalité",
  "candidate.field.numberOfFailedOralExams": "Examens oraux échoués",
  "candidate.field.numberOfFailedWrittenExams": "Examens écrits échoués",
  "candidate.field.placeOfOrigin": "Lieu d'origine",
  "candidate.header": "Candidats",
  "candidate.section.invoice": "Facture",
  "candidate.snackbar.successfulCreate": "le candidat a été ajouté",
  "candidate.snackbar.successfulDelete": "Le candidat sélectionné a été supprimé",
  "candidate.snackbar.successfulExport": "Le numéro de débiteur de l'abaque a été programmé pour l'exportation",
  "candidate.snackbar.successfulUpdate": "Les modifications ont été enregistrées",
  "candidate.validation.disabledFields": "Les champs ne peuvent pas être mis à jour après la confirmation",
  "candidate.validation.idNotEmpty": "L'ID du candidat ne doit pas être vide",
  "candidateAssignment.validation.preparationRoomNotAllowed.": "Un candidat ne peut pas être affecté à une salle de préparation.",
  "candidateCourse.certificate.fileNamePrefix": "Certificat",
  "candidateCourse.performanceRecord.fileNamePrefix": "Preuve de Performance",
  "candidateCourseStatus.open": "Ouvert",
  "candidateCourseStatus.passed": "Réussi",
  "candidateWizard.error": "L'inscription pour la certification a échoué",
  "candidateWizard.success": "Vous avez réussi! Vous devriez avoir reçu un courriel pour chaque inscription et vos examens apparaîtront dans la vue Candidat.",
  "canton.ag": "Argovie",
  "canton.ai": "Appenzell Rhodes-Intérieures",
  "canton.ar": "Appenzell Rhodes-Extérieures",
  "canton.be": "Berne",
  "canton.bl": "Bâle-Campagne",
  "canton.bs": "Bâle-Ville",
  "canton.fr": "Fribourg",
  "canton.ge": "Genève",
  "canton.gl": "Glaris",
  "canton.gr": "Grisons",
  "canton.ju": "Jura",
  "canton.lu": "Lucerne",
  "canton.ne": "Neuchâtel",
  "canton.nw": "Nidwald",
  "canton.ow": "Obwald",
  "canton.sg": "Saint-Gall",
  "canton.sh": "Schaffhouse",
  "canton.so": "Soleure",
  "canton.sz": "Schwyz",
  "canton.tg": "Thurgovie",
  "canton.ti": "Tessin",
  "canton.ur": "Uri",
  "canton.vd": "Vaud",
  "canton.vs": "Valais",
  "canton.zg": "Zoug",
  "canton.zh": "Zurich",
  "cart.validation.candidateIdNotEmpty": "L'ID du candidat doit être défini",
  "cart.validation.cartEmpty": "Le panier est vide.",
  "cart.validation.examAlreadyBooked": "Examen déjà réservé.",
  "cart.validation.examNotFound": "Examen non trouvé.",
  "cart.validation.missingCourseId": "ID de cours manquant",
  "cart.validation.missingExamDayIdOnExam": "Absence de l'identifiant du jour de l'examen sur l'examen.",
  "cart.validation.missingExamSessionId": "ID de session d'examen manquant",
  "cart.validation.missingInformationInModule": "Informations manquantes dans le module.",
  "cart.validation.missingModuleId": "ID de module manquant",
  "cart.validation.moduleAlreadyBooked": "Module déjà réservé.",
  "cart.validation.moduleAlreadyPaid": "Module déjà payé.",
  "cart.validation.moduleNotFound": "Module non trouvé dans le panier.",
  "certification.button.new": "Inscription À L'examen",
  "certification.examDate": "date d'examen",
  "certification.examType": "type d'examen",
  "certification.fachrichtung": "Option pour le cas de l'examen oral",
  "certification.state": "État",
  "certifications.noInfo": "pas de certifications disponibles",
  "common.accept": "Accepter",
  "common.archive": "Archiver",
  "common.attention": "Attention",
  "common.build": "Construire",
  "common.business": "Affaires",
  "common.cancel": "Annuler",
  "common.certificationsGenerated": "Certificats générés",
  "common.close": "Fermer",
  "common.comment": "Commentaire",
  "common.confirmArchiveDescription": "Voulez-vous vraiment archiver l'entité?",
  "common.confirmDeleteDescription": "Voulez-vous vraiment supprimer l'entité?",
  "common.confirmPublishDescription": "Êtes-vous sûr de vouloir publier cette entité ?",
  "common.copyToClipboard": "Copier dans le presse-papiers",
  "common.copyToClipboardDone": "Copié dans le presse-papiers",
  "common.debtorNumber": "Numéro du débiteur",
  "common.delete": "Supprimer",
  "common.dragAndDrop.description": "Glissez et déposez le document ici",
  "common.errorMessage": "Une erreur est survenue",
  "common.exam": "Examen",
  "common.export": "Exportation",
  "common.field.status": "Statut",
  "common.genders.female": "Femme",
  "common.genders.male": "Homme",
  "common.generateCertifications.confirmation": "êtes-vous sûr de vouloir générer des certifications?",
  "common.generateCertifications": "générer des certifications",
  "common.info": "Information",
  "common.language.de": "Allemand",
  "common.language.en": "Anglais",
  "common.language.fr": "Français",
  "common.language.it": "Italien",
  "common.language": "Langue",
  "common.languages": "Langues",
  "common.lastModification.by": "par",
  "common.lastModification.on": "le",
  "common.lastModification": "Dernière modification",
  "common.module": "Module",
  "common.no": "Non",
  "common.noLanguagesAssigned": "Aucune langue attribuée",
  "common.ok": "Ok",
  "common.orderId": "Identifiant de commande",
  "common.pleaseSelect": "S'il vous plaît choisir",
  "common.private": "Privé",
  "common.publish": "Publier",
  "common.reject": "Refusée",
  "common.rejected": "Rejeté",
  "common.roomLanguage": "Langue de la salle",
  "common.roomType": "Type de salle",
  "common.rowsPerPage": "colonnes par page",
  "common.save": "Sauvegarder",
  "common.scheduleCorrectionExams": "Planification de correction",
  "common.scheduleOralExams": "Planification des examens oraux",
  "common.scheduleWrittenExams": "Planification des examens écrits",
  "common.search": "Rechercher",
  "common.selectElement": "Sélectionner",
  "common.selectElements": "Sélectionner",
  "common.signOut": "Désinscrire",
  "common.status.archived": "Archivé",
  "common.status.cancelled": "Annulé",
  "common.status.deleted": "Supprimé ",
  "common.status.draft": "Brouillon",
  "common.status.published": "Publié",
  "common.survey": "Etude",
  "common.timeSlotStructure": "Structure de créneaux horaires",
  "common.total": "Total",
  "common.transaction.failMessage.declined": "L'institution de crédit a refusé le paiement. Veuillez essayer un autre moyen de paiement.",
  "common.transaction.id": "Identifiant de transaction",
  "common.unexpectedError": "Erreur inattendue. Veuillez réessayer plus tard.",
  "common.Unknown": "Inconnu",
  "common.unpublish": "Dépublier ",
  "common.uploadError": "Erreur dans le téléchargement. Le format n'est pas valalbe.",
  "common.uploadSizeError": "Erreur de téléchargement. Le fichier dépasse la taille maximale de {size} Mo.",
  "common.validation.entityWithIdNotExistsAndCanNotBeAssigned": "L'Entité avec l'ID donné n'a pas été trouvée et ne peut pas être assignée.",
  "common.validation.entityWithIdNotExistsAndCanNotBeDeleted": "L'Entité avec l'ID donné n'a pas été trouvée et ne peut pas être supprimée.",
  "common.validation.idNotEmpty": "L'ID ne peut pas être vide.",
  "common.validation.name.empty": "Le nom ne peut pas être vide.",
  "common.validation.status.empty": "Le statut ne peut pas être vide.",
  "common.validation.status.invalidTransition": "Cette transition de statut est invalide.",
  "common.validation.status.invalidValue": "La valeur du statut est incorrecte.",
  "common.yes": "Oui",
  "countries.switzerland.name": "Suisse",
  "course.button.addModules": "Ajout de modules",
  "course.dialog.confirmPublishDescription": "Êtes-vous sûr de vouloir publier ce cours ?",
  "course.dialog.noAvailableModules": "Aucun module disponible.",
  "course.dialog.selectModules": "Sélection de modules",
  "course.field.certificateValidity.FiveYears": "5 ans",
  "course.field.certificateValidity.Unlimited": "Illimité",
  "course.field.certificateValidity": "Validité de la certification",
  "course.field.moduleRelevantForGrade": "Pertinent pour la note du cours",
  "course.field.modulesValidity.days": "jours",
  "course.field.modulesValidity.unlimited": "Illimitée",
  "course.field.modulesValidity": "Validité des modules",
  "course.field.name": "Nom du cours",
  "course.field.nameDE": "Nom du cours - DE",
  "course.field.nameEN": "Nom du cours - EN",
  "course.field.nameFR": "Nom du cours - FR",
  "course.field.nameIT": "Nom du cours - IT",
  "course.field.numberOfMandatoryModules": "Nombre de modules obligatoires",
  "course.field.numberOfProcessModules": "Nombre de modules de processus",
  "course.field.numberOfSelectionModules": "Nombre de modules en sélection",
  "course.header": "Cours",
  "course.list.header": "Cours",
  "course.section.modules": "Modules",
  "course.snackbar.successfulArchive": "Le cours a été archivé avec succès.",
  "course.snackbar.successfulDelete": "Le cours a été supprimé avec succès.",
  "course.snackbar.successfulPublish": "Le cours a été publié avec succès.",
  "course.type.cicero": "Brevet fédéral/Cicero",
  "course.type.ciceroGroup": "Groupe de Brevet fédéral/Cicero",
  "course.type.hve": "FPS",
  "course.type.hveGroup": "Groupe de FPS",
  "course.type.intermediary": "Intermédiaire",
  "course.type.intermediaryGroup": "Groupe de Intermédiaire",
  "course.type.mindeststandard": "Normes minimales",
  "course.type.mindeststandardGroup": "Groupe de normes minimales",
  "course.type": "Type de cours",
  "course.validation.idNotEmpty": "L'ID du cours ne peut pas être vide.",
  "course.validation.modules.empty": "Veuillez choisir au moins un module.",
  "course.validation.numberOfAnyModulesIsZero": "Le nombre total de modules doit être au moins égal à 1.",
  "course.validation.typeIsInvalid": "Le type de cours est invalide.",
  "course.validation.typeNotEmpty": "Veuillez sélectionner le type de cours",
  "courseManagement.header": "Cours",
  "dragAndDrop.uploadFiles": "Télécharger les fichiers en les déposant ici",
  "exam.button.new": "Ajouter un nouveau examen",
  "exam.field.correctionExpenses": "Frais de correction",
  "exam.field.courseType": "Type de cours",
  "exam.field.examExpenses": "Frais d'examens",
  "exam.field.examId": "Identifiant d'examen",
  "exam.field.examName": "Nom de l'examen",
  "exam.field.examNameDE": "Nom de l'examen DE",
  "exam.field.examNameEN": "Nom de l'examen EN",
  "exam.field.examNameFR": "Nom de l'examen FR",
  "exam.field.examNameIT": "Nom de l'examen IT",
  "exam.field.expertExpenses": "Frais d'experts",
  "exam.field.type": "Type d'examen",
  "exam.header": "Examens",
  "exam.section.specifics": "Détails de l'examen",
  "exam.snackbar.successfulArchive": "L'examen sélectionné a été archivé",
  "exam.snackbar.successfulDelete": "L'examen sélectionné a été supprimé",
  "exam.snackbar.successfulPublish": "L'examen sélectionné a été publié",
  "exam.type.oral": "Examen oral",
  "exam.type.termPaper": "Travail écrit",
  "exam.type.written": "Examen écrit",
  "exam.validation.idNotEmpty": "Le nom de l'examen ne peut être videy",
  "examApplication.field.candidates": "candidats",
  "examApplication.field.case": "cas",
  "examApplication.validation.timeslotIsOverbooked": "Au moins un examen est surbooké. Cela peut se produire si de nouvelles applications sont ajoutées alors que des modifications sont apportées dans la vue de planification.",
  "examAssignment.validation.preparationRoomNotAllowed": "Un examen ne peut pas être attribué à une salle de préparation.",
  "examDay.button.assignExpertsToCorrectionExams": "Attribuer un expert en correction",
  "examDay.button.assignExpertsToOralExams": "Attribuer des experts pour les examens",
  "examDay.button.assignProctorsToOralPreparations": "Attribuer des surveillants à des examens oraux",
  "examDay.button.assignProctorsToWrittenExams": "Attribuer des surveillants à des examens écrits",
  "examDay.button.new": "Ajouter une nouvelle journée d'examen",
  "examDay.field.date": "Date",
  "examDay.field.header": "Jour de l'examen",
  "examDay.field.numberOfRoomsAssigned": "salles attribuées",
  "examDay.field.preparationRoom": "Salle de préparation",
  "examDay.field.timeSlotStructure.correction": "Correction",
  "examDay.field.timeSlotStructure.electiveWritten": "Vote par écrit",
  "examDay.field.timeSlotStructure.mandatoryWritten": "Obligatoire par écrit",
  "examDay.field.timeSlotStructure.oralHBB_ProcessModule": "Oral HBB module de procédure",
  "examDay.field.timeSlotStructure.oralIntermediary": "Oral médiateur",
  "examDay.field.timeSlotStructure.oralLife": "Partie d'examen vie",
  "examDay.field.timeSlotStructure.placeholder": "Créneaux horaires",
  "examDay.field.timeSlotStructure.writtenHBB_ProcessModule": "Écrit HBB module de procédure",
  "examDay.field.timeSlotStructure.writtenIntermediary": "Écrit médiateur",
  "examDay.field.timeSlotStructure": "Créneaux horaires",
  "examDay.field.type.correction": "Correction",
  "examDay.field.type.oral": "Oral",
  "examDay.field.type.written": "Écrit",
  "examDay.field.type": "Type",
  "examDay.validation.alreadyExistsForLocationOnSameDate": "Un jour d'examen avec la même date et le même lieu existe déjà.",
  "examDay.validation.examTypeUnknown": "Le type d'examen est inconnu. Veuillez choisir un type existant.",
  "examDay.validation.idNotEmpty": "L'ID du jour de l'examen ne peut pas être vide.",
  "examDay.validation.notFound": "Journée de l'examen non trouvée.",
  "examDay.validation.onlyOnePreparationRoomAllowed": "Une seule salle de préparation peut être ajoutée à la journée.",
  "examDay.validation.roomCanNotBeAssignedToSelectedExamType": "La salle ne peut pas être attribuée parce qu'elle ne s'applique pas au type d'examen de cette journée d'examen.",
  "examDay.validation.selectedRoomAlreadyAssigned": "La salle est déjà attribuée.",
  "examDay.validation.selectedRoomIsPcRoomAndCanNotBeUsed": "La salle est une salle informatique et ne peut pas être attribuée.",
  "examManagement.header": "Examens",
  "examScore.grade": "Classe",
  "examScore.points": "Points",
  "examSession.alert.builderInformation": "Veuillez noter que la construction de la session d'examen est un processus complexe. Assurez-vous de bien comprendre les implications de chaque étape avant de continuer.",
  "examSession.button.calculateExamResults": "Calculer les résultats d'examen",
  "examSession.button.exportCandidates": "Exporter les candidats par tranche horaire ou type d'examen",
  "examSession.button.exportOrders": "Exporter les commandes manquantes en XML",
  "examSession.button.importExamScoresAndGrades": "Importer des points et des notes",
  "examSession.button.importPev": "Importer le PEV",
  "examSession.button.new": "Ajouter une nouvelle session d'examen",
  "examSession.button.newBuilder": "Ajouter à l'aide du générateur",
  "examSession.button.newLife": "Ajouter une nouvelle session d'examen de vie",
  "examSession.button.publishExamResults": "Publier les résultats d'examen",
  "examSession.candidateExportDialog.examDay.label": "Date",
  "examSession.candidateExportDialog.examDay.placeholder": "Sélectionner une date",
  "examSession.candidateExportDialog.timeSlot.label": "Créneau horaire",
  "examSession.candidateExportDialog.timeSlot.placeholder": "Sélectionner un créneau horaire",
  "examSession.candidateExportDialog.title": "Sélectionner un type d'examen ou éventuellement un créneau horaire",
  "examSession.confirmPublishResultsDialog.text": "Êtes-vous sûr de vouloir publier les résultats des examens de cette session ?",
  "examSession.dialog.noAvailableCourses": "Cet examen n'est assigné à aucun cours.",
  "examSession.dialog.selectCourseTypes": "Sélectionnez Types de cours",
  "examSession.field.candidatePin": "Code PIN du candidat",
  "examSession.field.correctionPeriod": "Période de correction",
  "examSession.field.date": "Date",
  "examSession.field.examResultDate": "Heure du résultat de l'examen",
  "examSession.field.examSession": "Période d'examen",
  "examSession.field.examSessionDate": "Date de la session d'examen",
  "examSession.field.expertPin": "Code PIN de l'expert",
  "examSession.field.freeCancellationEndDate": "Annulation gratuite jusqu'au",
  "examSession.field.from": "De",
  "examSession.field.gradingConferenceDate": "Date de la commission d'examen",
  "examSession.field.hidePastSessions": "Masquer les sessions passées",
  "examSession.field.inspectionPeriod": "Inspection",
  "examSession.field.inspectionSignupEndDate": "Date de la fin de la phase d'inscription",
  "examSession.field.isLife": "Examen de vie",
  "examSession.field.lifeSessionsOnly": "Sessions life uniquement",
  "examSession.field.published": "Publié",
  "examSession.field.sessionKey": "Clé de session",
  "examSession.field.sessionKeyDE": "Session d'examen DE",
  "examSession.field.sessionKeyEN": "Session d'examen EN",
  "examSession.field.sessionKeyFR": "Session d'examen FR",
  "examSession.field.sessionKeyIT": "Session d'examen IT",
  "examSession.field.signup": "Inscription",
  "examSession.field.signupDate": "Date d'inscription",
  "examSession.field.signupEndDate": "Date de la fin d'inscription",
  "examSession.field.signupStartDate": "Date du début de l'inscription",
  "examSession.field.surveyDeadline": "date limite de la demande",
  "examSession.field.to": "À",
  "examSession.header": "Sessions d'examen",
  "examSession.importPevDialog.title": "Télécharger le fichier contenant les données PEV",
  "examSession.invitation.allLocations": "tous les lieux",
  "examSession.invitation.flagged": "Les emails ont été envoyés pour ce lieu",
  "examSession.invitation.selectLocations": "Sélectionner des lieux",
  "examSession.invitation.snackbar.candidates": "Les invitations ont été envoyées à {count} candidats.",
  "examSession.invitation.snackbar.experts": "Les invitations ont été envoyées à {count} experts.",
  "examSession.invitation": "Inviter des experts/candidates",
  "examSession.label.examSessionBuilder": "Constructeur de session d'examen",
  "examSession.label.revealCandidatePin": "Afficher le code PIN du candidat",
  "examSession.label.revealExpertPin": "Afficher le code PIN de l'expert",
  "examSession.mail.invitation": "envoyer l'invitation",
  "examSession.mail.notifyCandidates": "informer les candidats",
  "examSession.mail.survey": "commencer l'enquête",
  "examSession.result.examSessionCreated": "La session d'examen a été créée avec succès.",
  "examSession.result.NotGenerated": "les résultats des examens n'ont pas encore été générés",
  "examSession.select.assignNewLocation": "Attribuer un nouveau lieu",
  "examSession.validation.atLeastOneLanguageIsSelectedForEachRoom": "Au moins une langue doit être sélectionnée pour chaque salle.",
  "examSession.validation.betweenFromAndTo": "La période d'inscription doit se situer entre les dates De et À.",
  "examSession.validation.canNotBeDeletedBecauseLocationsInside": "La session d'examen ne peut pas être supprimée parce qu'elle a attribué un ou plusieurs lieux.",
  "examSession.validation.canNotBeUnpublishedBecauseExistingApplication": "La session d'examen ne peut pas être publiée car des applications d'examen existent déjà",
  "examSession.validation.canNotReapplyForDifferentLanguage": "Vous ne pouvez pas vous réinscrire à la même session d'examen avec une langue différente.",
  "examSession.validation.correctionEndDateLaterThanCorrectionStartDate": "La date de fin de correction doit être postérieure à la date de début de correction.",
  "examSession.validation.examsEndDateLaterThanExamsStartDate": "La date de fin des examens doit être postérieure à la date de début des examens.",
  "examSession.validation.examSessionFull": "L'examen sélectionné pour cette session d'examen est malheureusement complet entre-temps. Veuillez choisir un autre module ou une autre session d'examen.",
  "examSession.validation.examsNoCourseTypes": "Pour certains examens écrits ou oraux, aucun type de cours n'est attribué. Veuillez attribuer au moins un type de cours.",
  "examSession.validation.examWithNotAllowedCourseTypes": "Certains examens n'ont pas de types de cours valides assignés. Veuillez vous assurer que toutes les affectations sont correctes ou recharger la page.",
  "examSession.validation.freeCancellationNotPossible": "L'annulation gratuite n'est plus disponible.",
  "examSession.validation.idNotEmpty": "L'ID de la session d'examen ne peut pas être vide.",
  "examSession.validation.inspectionEndDateLaterThanInspectionStartDate": "La date de fin de l'inspection doit être postérieure à la date de début de l'inspection. ",
  "examSession.validation.locationAlreadyExists": "Le lieu existe déjà en session d'examen.",
  "examSession.validation.locationDoesNotExist": "Le lieu n'a pas été trouvé.",
  "examSession.validation.nameIsRequiredInAllLanguages": "Le nom de la session d'examen est requis dans toutes les langues.",
  "examSession.validation.noExamFoundToSignup": "Aucun examen n'a été trouvé pour s'inscrire.",
  "examSession.validation.notPublishedNoSurveyPossible": "Le questionnaire ne peut être lancé que si la session d'examen est publiée",
  "examSession.validation.notPublishedResultsPublishingNotPossible": "La publication des résultats des examens n'est pas possible car la session d'examen n'est pas publiée.",
  "examSession.validation.publishedNoUpdatePossible": "La session d'examen est publiée et ne peut pas être mise à jour.",
  "examSession.validation.signupEndDateLaterThanSignupStartDate": "La date de la fin de l'inscription doit être postérieure à la date du début de l'inscription.",
  "examSession.validation.signupStartDateLaterThanOrEqualFrom": "La date du début de l'inscription doit être égale ou postérieure à la date de De.",
  "examSession.validation.someErrorsOccurred": "Certains modules présentent des erreurs",
  "examSession.validation.toLaterThanFrom": "La date de fin de l'examen doit être postérieure à la date de début de l'examen.",
  "examSession.validation.toLaterThanSignupEndDate": "La date de fin de l'examen doit être postérieure à la date de fin d'inscription.",
  "examSession.validation.toLaterThanSignupStartDate": "La date de fin de l'examen doit être postérieure à la date de début de l'inscription.",
  "examSession.validation.withSameNameAlreadyExists": "Une autre session d'examen portant le même nom existe déjà.",
  "examSession.writtenExamScoresImportDialog.title": "Télécharger le fichier contenant le résultat des examens écrits",
  "examSession.writtenExamScoresImportDialog.uploadSuccess": "succès du téléchargement. Nombre de scores mis à jour",
  "examSessionCandidate.addCandidate": "Ajouter un candidat",
  "examSessionCandidate.addDialog.bookingWithInvoice": "Réservation avec facture",
  "examSessionCandidate.addDialog.candidate": "Candidat",
  "examSessionCandidate.addDialog.course": "Cours",
  "examSessionCandidate.addDialog.module": "Module",
  "examSessionCandidate.addDialog.rebookWithInvoice": "Rebook avec facture",
  "examSessionCandidate.addDialog.title": "Sélectionnez le candidat, le cours et le module",
  "examSessionCandidate.attachments": "Pièces jointes",
  "examSessionCandidate.averageGrade": "Score moyen",
  "examSessionCandidate.book": "Réserver",
  "examSessionCandidate.bookedBy": "Personne qui a fait la réservation",
  "examSessionCandidate.booking.error": "Votre sélection n'est plus disponible. Veuillez réessayer.",
  "examSessionCandidate.bookingAvailableWhenRebooked": "La sélection de l'examen sera disponible lorsque le module sera rebooké.",
  "examSessionCandidate.bookingDialog.selectDate": "Sélectionner une date",
  "examSessionCandidate.bookingDialog.selectLanguage": "Sélectionner une langue",
  "examSessionCandidate.bookingDialog.selectLocation": "Sélectionner un lieu",
  "examSessionCandidate.bookingDialog.title": "Lieu et date d'examen",
  "examSessionCandidate.bookingTimestamp": "Heure de réservation",
  "examSessionCandidate.cancel": "Annuler",
  "examSessionCandidate.cancellationTimestamp": "Heure d'annulation",
  "examSessionCandidate.cancelledBy": "Personne qui a fait l'annulation",
  "examSessionCandidate.cancelModuleMessage": "Êtes-vous sûr d'annuler ce module?",
  "examSessionCandidate.cancelModuleRefundInformation": "Si dans la période d'annulation gratuite, le module sera remboursé, sinon une tâche d'annulation sera créée.",
  "examSessionCandidate.certification": "Date de certification",
  "examSessionCandidate.exam": "Examen",
  "examSessionCandidate.examDate": "Date d'examen",
  "examSessionCandidate.examType": "Type d'examen",
  "examSessionCandidate.isRepeater": "Répétiteur",
  "examSessionCandidate.locationAndDateEdit": "Modifier le lieu et la date d'examen",
  "examSessionCandidate.module": "Module",
  "examSessionCandidate.option": "Option",
  "examSessionCandidate.orderDetails": "Détails de la commande",
  "examSessionCandidate.paymentState": "Statut de paiement",
  "examSessionCandidate.publishResultsToEmployer": "Transmettre le résultat de l'examen",
  "examSessionCandidate.rebook": "Réserver de nouveau",
  "examSessionCandidate.resetManualState": "Définir le statut automatiquement",
  "examSessionCandidate.selectExamToRebook": "Sélectionnez un examen à rebooker",
  "examSessionCandidate.setManualState": "Définir le statut manuellement",
  "examSessionCandidate.state": "Statut",
  "examSessionCandidate.validation.examAlreadyBookedForAnotherModule": "L'examen est déjà réservé pour un autre module.",
  "examSessionCandidate.validation.examNotFound": "L'examen n'a pas été trouvé.",
  "examSessionCandidate.validation.idNotEmpty": "L'ExamSessionCandidate ID ne doit pas être vide.",
  "examSessionCandidate.validation.invalidGrade": "La note n'est pas valable.",
  "examSessionCandidate.validation.invalidScore": "Le résultat est invalide.",
  "examSessionCandidate.verificationRequired": "Vérification requise",
  "examSessionCandidateExamState.booked": "Réservé",
  "examSessionCandidateExamState.cancelled": "Annulé",
  "examSessionCandidateExamState.equivalence": "Équivalence",
  "examSessionCandidateExamState.failed": "Examen non réussi",
  "examSessionCandidateExamState.passed": "Examen réussi",
  "examSessionCandidateModuleState.applicationAccepted": "Demande acceptée",
  "examSessionCandidateModuleState.cancelled": "Annulé",
  "examSessionCandidateModuleState.Cancelled": "Module annulé. Une tâche système a été créée",
  "examSessionCandidateModuleState.equivalence": "Équivalence",
  "examSessionCandidateModuleState.expired": "Expiré",
  "examSessionCandidateModuleState.failed": "Module non réussi",
  "examSessionCandidateModuleState.passed": "Module réussi",
  "examSessionCandidateModuleState.Refunded": "Module remboursé",
  "examSessionCandidateModuleState.verificationRequired": "Vérification requise",
  "examSessions.noInfo": "pas de session d'examen",
  "examState.booked": "Réservé",
  "examState.cancelled": "Annulé",
  "examState.none": "---",
  "expert.button.new": "ajouter de nouveaux experts",
  "expert.field.courseType.placeholder": "Sélectionner les types de cours pour le rôle",
  "expert.field.exam.placeholder": "Sélectionner les examens pour le rôle",
  "expert.field.exam": "Examen FR",
  "expert.field.languages": "Langues",
  "expert.field.role.add": "Ajouter un nouveau rôle",
  "expert.field.role.Aufsichtsexperten": "Surveillant-expert",
  "expert.field.role.delete": "Supprimer le rôle",
  "expert.field.role.EinspracheKomission": "Commission des recours",
  "expert.field.role.Expertenschulung": "Seminaire des experts",
  "expert.field.role.Hauptexperten": "Experts principaux",
  "expert.field.role.Leiterprüfungszentrum": "Responsable du centre d'examen",
  "expert.field.role.placeholder": "Sélectionner de nouveaux rôles",
  "expert.field.role.Prüfungsexperten": "Experts d'examen",
  "expert.field.role.Prüfungskomission": "Commission d'examen",
  "expert.field.role.QSK": "Commission de la garantie de la qualité",
  "expert.field.role": "Rôles",
  "expert.header": "Experts",
  "expert.snackbar.successfulCreate": "L'expert a été ajouté",
  "expert.snackbar.successfulDelete": "L'expert selectionné a été supprimé",
  "expert.snackbar.successfulUpdate": "Les modifications ont été sauvegardées",
  "expert.validation.idNotEmpty": "L'ID de l'expert ne doit pas être vide",
  "expertAssignment.validation.examNotAssignedToRoom": "Examen sans attribution de salle",
  "expertAssignment.validation.expertAssignedToMultipleRoomsOnSameDay": "L'Expert est affecté dans différentes salles le même jour",
  "expertAssignment.validation.expertNotRequiredRole": "L'expert n'a pas le rôle requis",
  "expertAssignment.validation.expertNotSpeakingAnySupportedLanguage": "L'expert ne parle aucune des langues requises",
  "expertAssignment.validation.roomNotAssignedToExamDay": "La salle n'est pas affectée le jour de l'examen",
  "expertAvailability.header": "Disponibilité",
  "expertAvailability.noDatesAvailable": "il n'y a pas de dates disponibles pour le moment",
  "expertAvailability.surveyDeadlinePassed": "Le délai pour la saisie de la disponibilité est dépassé",
  "expertCorrectionAvailability.header": "Disponibilité pour la correction de l'examen",
  "file.name": "Nom du fichier",
  "home.candidate": "Point de vue du candidat",
  "home.expert": "Point de vue d'expert",
  "home.header": "page d'accueil",
  "home.me.edit": "Gérer le compte",
  "home.me": "Mes réglages",
  "home.myAlertFields.link": "Veuillez gérer votre compte.",
  "home.myAlertFields": "Certaines informations obligatoires sont nécessaires.",
  "home.myCertifications": "Mes certifications",
  "home.myCourses.downloadCertificate": "Certificat",
  "home.myCourses.downloadPerformanceRecord": "Preuve de performance",
  "home.myCourses.table.ClosingDate": "Date de clôture",
  "home.myCourses.table.downloads": "Téléchargements",
  "home.myCourses": "Mes Cours",
  "home.myExamCases": "Mon cas d'examen",
  "home.myExamResults": "Mes résultats d'examen",
  "home.myExams.newApplication": "Inscription à l'examen",
  "home.myExams.noExams": "Aucun examen disponible",
  "home.myExams.table.actionsColumn": "Actions",
  "home.myExams.table.dateColumn": "Date",
  "home.myExams.table.examColumn": "Examen",
  "home.myExams.table.examTypeColumn": "Type d'examen",
  "home.myExams.table.gradeColumn": "Classe",
  "home.myExams.table.locationColumn": "Location",
  "home.myExams.table.moduleColumn": "Module",
  "home.myExams.table.roomColumn": "Salle",
  "home.myExams.table.statusColumn": "Statut",
  "home.myExams.table.timeColumn": "Heure",
  "home.myExams": "Mes examens",
  "home.myExamSessions": "Ma session d'examen",
  "home.myFiles": "Mesdevoirs",
  "home.myTasks": "Mes devoirs",
  "home.pendingItemsInCartMessage": "Vous n'avez pas encore payé les modules. Souhaitez-vous maintenant poursuivre la réservation ? Veuillez noter que la place dans un module n'est pas réservée tant que vous n'avez pas payé.",
  "home.switch.candidate": "Passer à la vue candidat",
  "home.switch.expert": "Passer en vue expert",
  "icon.state.completed": "Terminé",
  "icon.state.error": "Erreur",
  "icon.state.fullyBooked": "Complet",
  "icon.state.incomplete": "Incomplet",
  "icon.state.paid": "Payé",
  "import.pev.bookingFailed": "Il n'est pas possible d'inscrire tous les candidats.",
  "import.pev.failedImportCandidates": "Échec de l'importation des candidats.",
  "import.pev.failedImportScoresAndGrades": "Échec de l'importation des résultats et des notes.",
  "import.pev.invalidCsv": "Fichier CSV non valide.",
  "import.pev.missingEntities": "Certaines entités n'ont pas été trouvées. ID des candidats : {candidateIds}. Sessions d'examen IDs : {examSessionsIds}. Cours IDs : {courseIds}. Modules IDs : {moduleIds}. Examens IDs : {examIds}.",
  "import.pev.noExam": "Impossible de trouver l'examen. ID de l'examen : {examId}.",
  "import.pev.noExamDayForExam": "Impossible de trouver un jour d'examen disponible pour l'examen. ID de la session d'examen : {examSessionId}. ID de l'examen : {examId}. Langue : {language}.",
  "import.pev.success": "Les données PEV ont été importées avec succès.",
  "import.pev.wrongCourseModules": "Les modules ne sont pas liés au cours. ID du cours : {courseId}. Modules IDs : {moduleIds}.",
  "import.pev.wrongExamSessionExams": "Les examens ne sont pas liés à la session d'examen. ID de la session d'examen : {examSessionId}. ID des examens : {examIds}.",
  "import.pev.wrongModuleExams": "Les examens ne sont pas liés au module. ID du module : {moduleId}. Examens IDs : {examIds}.",
  "lifeExams.back": "Retour",
  "lifeExams.book": "Réserver",
  "lifeExams.confirm": "Confirmer",
  "lifeExams.label.displayFullyBooked": "Afficher également les sessions complètes",
  "lifeExams.label.register": "Sélectionner",
  "lifeExams.label.sesionFullyBooked": "Pas de places libres",
  "lifeExams.messages.courseNotFound": "Le cours n'a pas été trouvé.",
  "lifeExams.messages.infoAlertAddUpdateOrConfirmPersonalData": "Veuillez saisir, mettre à jour ou confirmer vos données personnelles avant de réserver un examen.",
  "lifeExams.messages.infoAlertExams": "Seules les places d'examen libres en {lang} sont affichées.",
  "lifeExams.messages.infoAlertExamSessions": "Seuls les mois avec des places d'examen libres sont affichés",
  "lifeExams.messages.noAvailableExams": "Aucun examen disponible",
  "lifeExams.messages.warnAlertReservation": "Veuillez noter que votre place n'est pas réservée tant que vous n'avez pas payé.",
  "lifeExams.pay": "Réserver + Payer",
  "lifeExams.paymentErrorInitializing": "Erreur lors de l'initialisation du paiement",
  "lifeExams.redirectToMyVbv": "Redirection vers MyVBV dans {secondsLeft} secondes",
  "lifeExams.sessionAlreadyBooked": "Session d'examen déjà réservée",
  "lifeExams.title": "Sélectionner une date d'examen",
  "lifeExams.transactionCancelled": "La transaction {transactionId} a été annulée",
  "lifeExams.transactionFailed": "Échec de la transaction {transactionId}. Raison: ",
  "lifeExams.transactionPaid": "Vous êtes inscrit pour l'examen et recevrez bientôt une confirmation de réservation par courriel.",
  "lifeExams.waitingList": "Liste d'attente",
  "location.button.new": "Ajouter un nouveau lieu",
  "location.field.canton.placeholder": "Choisir un canton",
  "location.field.canton": "Canton",
  "location.field.city": "Ville",
  "location.field.contactEmailAddress": "Email de contact",
  "location.field.contactName": "Nom du contact",
  "location.field.contactPhoneNo": "Téléphone du contact",
  "location.field.languageRegions": "Régions linguistiques",
  "location.field.linkToMap": "Plan de situation",
  "location.field.name": "Nom",
  "location.field.street": "Rue",
  "location.field.zipCode": "Code Postal",
  "location.header": "Emplacements",
  "location.validation.idNotEmpty": "L'ID d'emplacement ne peut pas être vide",
  "location.validation.languageUnknown": "La langue est inconnue. Veuillez choisir une langue existante",
  "location.validation.nameAlreadyExists": "Un autre emplacement portant le même nom existe déjà.",
  "location": "Lieu",
  "login.button.adminLogin": "Login VBV-Admin",
  "login.button.impressum": "Impressum",
  "login.button.impressumLink": "https://www.vbv.ch/fr/impressum",
  "login.button.login": "Login",
  "login.error.errorLoadingAppRegistration": "Erreur lors de la récupération de la configuration.",
  "login.text.external1": "Connectez-vous pour accéder à l'application.",
  "login.text.external2": "Veuillez utiliser un navigateur moderne tel que Chrome ou Edge. Cette plateforme fonctionne exclusivement avec un ordinateur portable ou de bureau. Elle ne fonctionne pas avec une tablette ou un téléphone mobile.",
  "login.text.externalWarn": "Important",
  "login.title.external": "Inscription en tant que candidat/expert",
  "module.button.new": "Ajouter un nouveau module",
  "module.dialog.confirmPublishDescription": "Êtes-vous sûr de vouloir publier ce module?",
  "module.dialog.noAvailableExams": "Aucun examen disponible.",
  "module.dialog.noAvailableLocations": "Aucun lieu n'est disponible.",
  "module.dialog.selectExams": "Sélection d'examens",
  "module.dialog.selectLocations": "Sélectionner les lieux",
  "module.field.abacusNumber": "Nombre Abacus",
  "module.field.allowDocumentUpload": "Autoriser le téléchargement de documents",
  "module.field.allowOptions": "Autoriser les options",
  "module.field.allowRegistrationOnlyOnce": "Disponible une fois",
  "module.field.allRoomsAssigned": "Pièce assignée",
  "module.field.certificateValidity.FiveYears": "5 ans",
  "module.field.certificateValidity.OneYear": "1 an",
  "module.field.certificateValidity.Unlimited": "Illimité",
  "module.field.certificateValidity": "Validité de la certification",
  "module.field.documentsUploaded": "Documents téléchargés",
  "module.field.gradingRules.allExams": "Tous les examens doivent être réussis",
  "module.field.gradingRules.averageGrade": "Score moyen",
  "module.field.gradingRules": "Règles de notation",
  "module.field.moduleId": "ID du module",
  "module.field.moduleName": "Nom du module",
  "module.field.moduleNameDE": "Nom du module DE",
  "module.field.moduleNameEN": "Nom du module EN",
  "module.field.moduleNameFR": "Nom du module FR",
  "module.field.moduleNameIT": "Nom du module IT",
  "module.field.moduleType.mandatory": "Obligatoire",
  "module.field.moduleType.optionalModule": "Module au choix",
  "module.field.moduleType.processModule": "Module de processus",
  "module.field.moduleType": "Type de module",
  "module.field.needsApproval": "Doit être approuvé",
  "module.field.paymentState": "Statut de paiement",
  "module.field.price": "Prix en CHF",
  "module.field.verificationRequired": "Vérification requise",
  "module.header": "Modules",
  "module.moduleDetails": "Détails du module",
  "module.section.specifics": "Spécifique au module",
  "module.snackbar.successfulArchive": "Le module a été archivé avec succès.",
  "module.snackbar.successfulDelete": "Le module a été supprimé avec succès.",
  "module.snackbar.successfulPublish": "Le module a été publié avec succès.",
  "module.validation.gradingRule.invalidValue": "La règle de notation est invalide.",
  "module.validation.idNotEmpty": "L'ID du module ne peut pas être vide.",
  "module.validation.invalidStatusTransition": "La transition de statut est invalide.",
  "module.validation.invalidStatusValue": "La valeur du statut est incorrecte.",
  "module.validation.statusNotEmpty": "Le statut ne doit pas être vide.",
  "oralExamOption.kmu": "Petites entreprises",
  "oralExamOption.none": "Aucune",
  "oralExamOption.privathaushalte": "Ménage privé",
  "paymentMethodSelector.form.button": "Payer par facture",
  "paymentMethodSelector.item.creditCard": "Carte de crédit / Twint",
  "paymentMethodSelector.item.invoice": "Facture",
  "paymentMethodSelector.item.invoiceMessage": "Adresse privée (CH)",
  "paymentMethodSelector.title": "Choisir le mode de paiement",
  "paymentStatus.paid.abacus": "Facturé (Abacus)",
  "paymentStatus.paid.ePayment.cembraPay": "Payé (E-Payment: CembraPay)",
  "paymentStatus.paid.ePayment.creditCard": "Payé (E-Payment: Carte de crédit / Twint)",
  "paymentStatus.refunded.abacus": "Remboursé (Abacus)",
  "paymentStatus.refunded.ePayment.cembraPay": "Remboursé (E-Payment: CembraPay)",
  "paymentStatus.refunded.ePayment.creditCard": "Remboursé (E-Payment: Carte de crédit / Twint)",
  "person.field.activateSpecificProfile": "Activer le profil d'expert",
  "person.field.ahvNumber": "Numéro AVS",
  "person.field.bankAccount": "Compte bancaire",
  "person.field.birthDate": "Date de naissance",
  "person.field.ciceroNumber": "Numéro Cicero",
  "person.field.city": "Lieu de résidence",
  "person.field.country": "Pays",
  "person.field.displayName": "Nom",
  "person.field.email": "Email",
  "person.field.employer": "Employeur",
  "person.field.employerCity": "Ville de l'employeur",
  "person.field.employerCountry": "Sélectionner le Pays de l'employeur",
  "person.field.employerStreet": "Rue de l'employeur",
  "person.field.employerStreetNumber": "Numéro de rue de l'employeur",
  "person.field.employerZipCode": "Code postal de l'employeur",
  "person.field.firstName": "Prénom",
  "person.field.gender.placeholder": "Choisir un genre",
  "person.field.gender": "genre",
  "person.field.homeCountry": "Pays d'origine",
  "person.field.icon": "Symbole de l'acteur",
  "person.field.internalComment": "Commentaire interne",
  "person.field.lastName": "Nom de famille",
  "person.field.mobileNumber": "Numéro de mobile",
  "person.field.phoneNumber.placeholder": "Format: +41123456789",
  "person.field.phoneNumber": "Numéro de téléphone",
  "person.field.showOnlyExperts": "N'afficher que les experts",
  "person.field.street": "Rue",
  "person.field.streetNumber": "Numéro",
  "person.field.zipCode": "Code postal du lieu de résidence",
  "person.section.address": "Adresse privée",
  "person.section.businessData": "Informations professionnelles",
  "person.section.expertDetails": "Détails spécifiques à l'expert",
  "person.section.personalDetails": "Détails personnels",
  "person.validation.ahvNumberAlreadyExists": "Un autre utilisateur avec le même numéro AVS existe déjà",
  "person.validation.ahvNumberNotValid": "Le numéro AVS n'est pas valable",
  "person.validation.bankAccountNotEmpty": "Le compte en banque ne peut pas être vide",
  "person.validation.ciceroNumberAlreadyExists": "Un autre utilisateur avec le même numéro Cicero existe déjà",
  "person.validation.ciceroNumberNotValid": "Le numéro Cicero n'est pas valable",
  "person.validation.confirmEmailChange": "L'adresse email a été modifiée. Cela changera également le nom d'utilisateur de connexion. Êtes-vous sûr de vouloir continuer ?",
  "person.validation.emailAlreadyExists": "Un autre utilisateur avec le même email existe déjà",
  "person.validation.genderUnknown": "Le genre est inconnu. Veuillez choisir un genre existant",
  "person.validation.invalidEmployerZipCode": "Le code postal de l'employeur est invalide.",
  "person.validation.invalidZipCode": "Le code postal du lieu de résidence est invalide.",
  "person.validation.mandatoryExamRolesWithNoExams": "Il y a des rôles d'examen obligatoires qui n'ont pas d'examens assignés. Veuillez attribuer les examens manquants.",
  "person.validation.personEdiIdNotEmpty": "L'EDI Id ne peut pas être vide",
  "person.validation.personEmailAddressNotEmpty": "l'adresse e-mail ne peut pas être vide",
  "person.validation.repeatedRoles": "Les rôles sont répétés. Veuillez vous assurer qu'il n'y a pas de rôles répétés.",
  "person.validation.typeUnknown": "Le type de personne est inconnu. Veuillez choisir un type existant.",
  "role.validation.roleUnknown": "rôle inconnu",
  "room.button.new": "Nouvelle attribution de salle",
  "room.field.floor": "Emplacement",
  "room.field.isPcRoom": "Salle informatique",
  "room.field.name": "Nom",
  "room.field.numberOfSeats": "Capacité",
  "room.header": "Salle",
  "room.text.seats": "sièges",
  "room.validation.idNotEmpty": "L'ID de la salle ne peut pas être vide.",
  "room.validation.nameAlreadyExists": "Une autre salle portant le même nom existe déjà.",
  "roomAssignment.button.new": "Attribuer une salle",
  "roomAssignment.deleteConfirmation.title": "Vous êtes sur le point de retirer une salle de préparation. Veuillez vous assurer qu'il y a une salle de préparation affectée à cette date d'examen.",
  "roomAssignment.field.isPreparationRoom": "Salle de préparation",
  "roomAssignment.field.room.placeholder": "Choisir une salle",
  "roomAssignment.field.room": "Salle",
  "roomAssignment.header": "Attribution des salles",
  "roomAssignment.validation.idNotEmpty": "L'affectation de la chambre ne peut pas être vide",
  "scheduler.examSelectDialog.title": "Sélectionnez l'examen pour la salle",
  "scheduler.examSelectDialog.tooltip": "Fixer l'examen pour tous les créneaux horaires",
  "scheduler.message.briefing": "Briefing des experts",
  "scheduler.message.exam": "Examen",
  "scheduler.message.noExperts": "pas d'expert assigné",
  "scheduler.message.pause": "Pause",
  "scheduler.timeSlot.arrivalTime": "Heure d'arrivée",
  "selfcancellation.header": "Annuler le module",
  "selfcancellation.text": "Attention : Veuillez confirmer que vous souhaitez annuler votre inscription à l'examen.",
  "startCertification.button.back": "retour",
  "startCertification.button.finish": "terminé",
  "startCertification.button.next": "Suivant",
  "startCertification.courseModuleExamsStep.header": "Choisir le cours, le module et les examens",
  "startCertification.examDataStep.header": "Sélectionner le type d'examen, la salle et la date",
  "startCertification.examDataStep.selectCompany": "Sélectionner votre entreprise",
  "startCertification.examDataStep.selectExamSession": "Sélectionner une session d'examen",
  "startCertification.examDataStep.selectFachrichtung": "Sélectionner l'option",
  "startCertification.examDataStep.selectLocationOralPart": "Sélectionner un lieu pour la partie orale de votre examen",
  "startCertification.examDataStep.selectLocationWrittenPart": "Sélectionner un lieu pour votre examen écrit",
  "startCertification.examDataStep.selectOralExamDate": "Sélectionner une date pour l'examen oral",
  "startCertification.examDataStep.selectWrittenExamDate": "Sélectionner une date pour l'examen écrit",
  "startCertification.locationDateStep.header": "Choisir le lieu et la date de l'examen",
  "startCertification.modulesDetailsStep.dialogHelperText": "Veuillez compléter les informations manquantes et télécharger les documents requis si nécessaire.",
  "startCertification.modulesDetailsStep.docsText1": "Veuillez télécharger tous les documents requis pour ce module.",
  "startCertification.modulesDetailsStep.docsText2": "Si vous n'êtes pas en mesure de télécharger les documents pour le moment, veuillez l'indiquer ci-dessous. Nous vous attribuerons une tâche appropriée.",
  "startCertification.modulesDetailsStep.fillDetails": "Compléter les détails",
  "startCertification.modulesDetailsStep.header": "Fournir des informations et des documents",
  "startCertification.modulesDetailsStep.helperText": "Veuillez compléter les informations manquantes et télécharger les documents requis pour les modules sélectionnés.",
  "startCertification.modulesDetailsStep.isRepeater": "Je suis répétiteur",
  "startCertification.modulesDetailsStep.option.kmu": "PME",
  "startCertification.modulesDetailsStep.option.privathaushalte": "Privé",
  "startCertification.modulesDetailsStep.option": "Option",
  "startCertification.modulesDetailsStep.tableTitle": "Modules sélectionnés",
  "startCertification.modulesDetailsStep.trainingProvider": "Fournisseur de formation",
  "startCertification.modulesDetailsStep.willUploadDocsLater": "Télécharger les documents plus tard",
  "startCertification.moduleSelectionStep.header": "Choisir le cours, le module et les examens",
  "startCertification.moduleSelectionStep.helperText": "Veuillez sélectionner un cours et une session d'examen pour choisir les modules et les examens auxquels vous souhaitez vous inscrire.",
  "startCertification.moduleSelectionStep.priceColumn": "Prix en CHF",
  "startCertification.moduleSelectionStep.removeButton": "Retirer",
  "startCertification.moduleSelectionStep.selectButton": "Sélectionner",
  "startCertification.moduleSelectionStep.selectedModules": "Vos modules sélectionnés",
  "startCertification.paymentAndCompletionStep.actionColumn": "Action",
  "startCertification.paymentAndCompletionStep.button.confirm": "Réserver maintenant de manière ferme",
  "startCertification.paymentAndCompletionStep.button.confirmed": "Confirmé",
  "startCertification.paymentAndCompletionStep.button.paid": "Payé",
  "startCertification.paymentAndCompletionStep.button.pay": "Payer",
  "startCertification.paymentAndCompletionStep.freeCancelDate": "annulation gratuite jusqu'au ",
  "startCertification.paymentAndCompletionStep.generalInfo.cost1": "Passé ce délai, ",
  "startCertification.paymentAndCompletionStep.generalInfo.cost2bold": "la totalité des frais d'examen est due",
  "startCertification.paymentAndCompletionStep.generalInfo.cost3": " en cas de désinscription non justifiée.",
  "startCertification.paymentAndCompletionStep.generalInfo.freeCancellation": "L'inscription est obligatoire. Vous pouvez vous désinscrire sans frais jusqu'aux dates indiquées ci-dessus.",
  "startCertification.paymentAndCompletionStep.generalInfo.hveFAQLink": "https://www.vbv.ch/fileadmin/vbv/Dokumente/Bildungsabschluesse/Versicherungsfach/72047_PO_Versicherungsfachleut_F_2022__1_.pdf",
  "startCertification.paymentAndCompletionStep.generalInfo.hveFAQLinkText": "FAQ brevet fédéral",
  "startCertification.paymentAndCompletionStep.generalInfo.intermediaryFAQLink": "https://www.vbv.ch/fileadmin/vbv/Dokumente/Bildungsabschluesse/Versicherungsvermittlung/FAQ_Vermi_Pruefungen_fr.pdf",
  "startCertification.paymentAndCompletionStep.generalInfo.intermediaryFAQLinkText": "FAQ intermédiaire d'assurance",
  "startCertification.paymentAndCompletionStep.generalInfo.moreInformation1": "Vous trouverez de plus amples informations dans la ",
  "startCertification.paymentAndCompletionStep.generalInfo.moreInformation2": ".",
  "startCertification.paymentAndCompletionStep.header": "Paiement et conclusion",
  "startCertification.paymentAndCompletionStep.hint": "Veuillez noter que votre place dans un module n'est pas réservée jusqu'au paiement.",
  "startCertification.paymentAndCompletionStep.messages.transactionCancelled": "Transaction {id} annulée",
  "startCertification.paymentAndCompletionStep.messages.transactionConfirmed": "La transaction {id} a été confirmée",
  "startCertification.paymentAndCompletionStep.messages.transactionFailed": "Échec de la transaction {id}",
  "startCertification.paymentAndCompletionStep.messages.transactionPaid": "La transaction {id} a été payée",
  "startCertification.paymentAndCompletionStep.messages.wrongTransactionId": "ID de transaction invalide {id}",
  "startCertification.paymentAndCompletionStep.moduleFullyBooked": "Complet",
  "startCertification.paymentAndCompletionStep.paymentConfirmationMessagePart1": "Cela peut prendre jusqu'à une minute. Ce message sera automatiquement fermé lorsque le paiement aura été confirmé.",
  "startCertification.paymentAndCompletionStep.paymentConfirmationMessagePart2": "Sinon, veuillez contacter VBV avec l'ID de transaction : {datatransTrxId}",
  "startCertification.paymentAndCompletionStep.paymentConfirmationTitle": "En attente de la confirmation de paiement, veuillez patienter",
  "startCertification.paymentAndCompletionStep.removeModule": "Supprimer le module",
  "startCertification.paymentAndCompletionStep.removeModuleConfirmation": "Voulez-vous supprimer le module?",
  "startCertification.paymentAndCompletionStep.summary": "Résumé",
  "startCertification.personalDataStep.header": "Vérifiez vos données",
  "startCertification.policyDialog.accept.link": "la politique de confidentialité/CGV",
  "startCertification.policyDialog.accept.linkUrl": "https://www.vbv.ch/fr/politique-de-confidentialite",
  "startCertification.policyDialog.accept": "J'accepte par la présente ",
  "startCertification.policyDialog.text1": "Par la présente, je prends connaissance et j'accepte que les informations suivantes soient communiquées à mon employeur : inscription à une session d'examen, y compris la date de la session, les résultats de l'examen, y compris les notes/points et si l'examen a été réussi ou non, inscription au registre Cicero ",
  "startCertification.policyDialog.text2": "Le présent consentement peut être révoqué à tout moment et librement vis-à-vis de l'Association pour la formation professionnelle en assurance AFA par lettre ou e-mail à vermittler@vbv-afa.ch.",
  "startCertification.uploadFilesStep.header": "télécharger les fichiers pour vérification",
  "table.noRecords": "aucun enregistrement trouvé",
  "task.creationDate": "Date de création",
  "task.deadline": "date limite",
  "task.noInfo": "pas de tâches en attente",
  "task.state": "Statut",
  "task.type": "Type",
  "task.validation.deadlineMustBeLaterThanToday": "Le délai doit être postérieur à aujourd'hui",
  "task.validation.typeUnknown": "Type des tâches inconnu",
  "taskState.done": "effectué",
  "taskState.inProgress": "en cours",
  "taskState.toDo": "à faire",
  "taskType.cancellation": "Annulation",
  "taskType.checkAvailability": "contrôler la disponibilité",
  "taskType.checkCorrectionAvailability": "Entrez la disponibilité pour la correction de l'examen",
  "taskType.none": "aucun",
  "taskType.uploadDocuments": "Téléchargement de documents",
  "uploadDocumentsTask.header": "Tâche de téléchargement de documents",
  "uploadDocumentsTask.instructions": "Veuillez télécharger tous les documents requis pour ce module et compléter la tâche lorsque terminé.",
  "user.noInfo": "aucune information sur l'utilisateur",
  "user.settings": "Paramètre",
  "userRoomAssignment.assignment": "Attribution",
  "userRoomAssignment.label.allExpertsSwitch": "Afficher tous les experts",
  "userRoomAssignment.label.fixed": "Fixes",
  "userRoomAssignment.label.fixedCorrectionExperts": "Experts corrections fixés",
  "userRoomAssignment.label.fixedExperts": "Experts fixes(2x)",
  "userRoomAssignment.label.fixedProctors": "Surveillants fixes (2x)",
  "userRoomAssignment.label.reserve": "En réserve",
  "userRoomAssignment.label.reserveCorrectionExperts": "Experts en correction en réserve",
  "userRoomAssignment.label.reserveExperts": "Experts en réserve",
  "userRoomAssignment.label.reserveProctors": "Suveillants en réserve ",
  "userRoomAssignment.label.roomFull": "La salle est complète",
  "userRoomAssignment.label.roomOverload": "La salle est surchargée",
  "userRoomAssignment.placeholder.selectFixedExperts": "Sélectionner des experts fixes",
  "userRoomAssignment.placeholder.selectFixedProctors": "Sélectionner des surveillants fixes",
  "userRoomAssignment.placeholder.selectReserveExperts": "Sélectionner des experts en réserve",
  "userRoomAssignment.placeholder.selectReserveProctors": "Sélectionner des surveillants en réserve",
};
